"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OutputBuffer = void 0;
const utils_1 = require("@streamr/utils");
const errors_1 = require("../helpers/errors");
class OutputBuffer {
    buffer = [];
    deferredPromise = new utils_1.Defer();
    push(message) {
        this.buffer.push(message);
        return this.deferredPromise;
    }
    getBuffer() {
        return this.buffer;
    }
    resolve() {
        this.buffer.length = 0;
        this.deferredPromise.resolve();
    }
    reject() {
        this.buffer.length = 0;
        this.deferredPromise.reject(new errors_1.SendFailed('Could not send buffered messages'));
    }
}
exports.OutputBuffer = OutputBuffer;
//# sourceMappingURL=OutputBuffer.js.map